import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import { AddCobroFijoComponent } from '../add-cobro-fijo/add-cobro-fijo.component';
import { CarteraService } from 'app/services/cartera/cartera.service';
import { TesoreriaPrepago } from 'app/entities/cobranza';
import * as moment from 'moment';

@Component({
  selector: 'app-tesoreria-prepago',
  templateUrl: './tesoreria-prepago.component.html',
  styleUrls: ['./tesoreria-prepago.component.scss']
})
export class TesoreriaPrepagoComponent implements OnInit {

  newForm: FormGroup;
  public informacionGrupo: TesoreriaPrepago;

  /**
   * Constructor
   * 
   * @param _data 
   * @param {MatDialogRef<AddCobroFijoComponent>} _dialog 
   * @param {CarteraService} _cartera 
   * @param {MatSnackBar} _snackBar 
   * @param {FormBuilder} _formBuilder 
   */
  constructor
  (
    @Inject(MAT_DIALOG_DATA) private _data, 
    public _dialog: MatDialogRef<AddCobroFijoComponent>,
    private _cartera: CarteraService,
    private _snackBar: MatSnackBar,
    private _formBuilder: FormBuilder,
  ) 
  { 
    this.informacionGrupo = {
      documento: _data.grunit,
      radicado: _data.grugru,
      nombre: _data.nombre,
      base_datos: _data.database === 'Vital Mascotas' ? 'medisoftvet' : 'medisoft'
    }
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On Init
   */
  ngOnInit() {
    this.newForm = this.createForm();
    this._cartera.VerFechasContratoxGrupo(this.informacionGrupo.documento, this.informacionGrupo.base_datos)
                  .subscribe((data: any) => {
                    this.asignarForm(data[0]);
                  }); 
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Creación del FormGroup
   * @returns {FormGroup}
   */
  createForm(): FormGroup {
    return new FormGroup({
      inicio_Contrato: new FormControl(),
      fin_Contrato: new FormControl(),
      aviso: new FormControl(),
      observaciones: this._formBuilder.group({
        contrato: new FormControl(),
        cartera: new FormControl()
      })
    });
  }

  /**
   * Asigna el argumento 'data' al formulario(newForm)
   * @param data 
   */
  asignarForm(data): void {
    this.newForm.patchValue({
      inicio_Contrato: data.inicio_contrato,
      fin_Contrato: data.fin_contrato,
      aviso: data.aviso,
      observaciones: {
        contrato: data.observacion_contrato,
        cartera: data.observacion_cartera
      }
    });
  }

  /**
   * Modifica todo lo relacionado con el contrato del grupo
   * @param form 
   */
  public updateContrato(form): void {

    // Aplicación del formato Año-Mes-Dia(YYYY-MM-DD) a los campos inicio_Contrato, fin_Contrato y aviso del formulario(NewForm)
    this.newForm.patchValue({
      inicio_Contrato: moment(form.inicio_Contrato).format('YYYY-MM-DD'),
      fin_Contrato: moment(form.fin_Contrato).format('YYYY-MM-DD'),
      aviso: moment(form.aviso).format('YYYY-MM-DD')
    });

    this._cartera.EditarFechasContrato(this.informacionGrupo.base_datos, this.informacionGrupo.documento, this.newForm.value)
                  .subscribe((data: any) => {
                    // Condición: Sí hay filas editadas, muestra un mensaje de éxito y cierra el modal retornando verdadero(TRUE), de lo contrario, muestra un mensaje de error
                    if(data.changedRows == 1){
                      this._snackBar.open('Contrato Actualizado', 'Aceptar', {
                        duration: 2000
                      });
                      this._dialog.close(true);
                    }else{
                      this._snackBar.open('Error: Contrato no actualizado', '', {
                        duration: 2000,
                        panelClass: ['warn-600']
                      });
                    }
                  });
  }

}
